import { Parameter } from '../script/parameter.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

@jsonClass('ConfigItemSelectionOption')
export class ConfigItemSelectionOption {
	@jsonProperty(String)
	value?: string
	@jsonProperty(String)
	displayName?: string

	constructor(init?: Partial<ConfigItemSelectionOption>) {
		assignCommonProperties(this, init)
	}
}

@jsonClass('ConfigurationItemProperty')
export class ConfigurationItemProperty extends Parameter {
	@jsonProperty(String)
	inputType: 'dropdown' | 'input' = 'input'
	@jsonArrayProperty(ConfigItemSelectionOption)
	selectionOptions: ConfigItemSelectionOption[] = []
	@jsonProperty(String)
	validationRegex: string = ''
	@jsonProperty(String)
	hint: string = ''
	@jsonProperty(Boolean)
	isSecret: boolean = false
	@jsonProperty(Boolean)
	isAvailableOnClient: boolean = true
	isApplicable: (config: any) => boolean = () => true
	order = 0

	constructor(init?: Partial<ConfigurationItemProperty>) {
		super()
		assignCommonProperties(this, init)
	}
}
